import * as keyapis_notification_v1_push_token_pb from "./v1/keyapis_notification_push_token_v1.pb";
import * as keyapis_notification_v1_system_pb from "./v1/keyapis_notification_system_v1.pb";

export default {
  v1: {
    resources: {
      pushToken: keyapis_notification_v1_push_token_pb,
      system: keyapis_notification_v1_system_pb,
    },
  },
};
